<div class="row">
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5">
            <div class="text-black-50 pb-2">
                Expenses
            </div>
            <div class="d-flex justify-content-between align-items-end">
                <h3 class="display-4 mb-0 text-black">
                    <small class="pr-1 text-black-50">
                        $
                    </small>
                    <span [countUp]="4986" class="text-success"></span>
                </h3>
                <div class="text-success font-weight-bold">
                    +34%
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5">
            <div class="text-black-50 pb-2">
                Sales
            </div>
            <div class="d-flex justify-content-between align-items-end">
                <h3 class="display-4 mb-0 text-black">
                    <small class="pr-1 text-black-50">
                        $
                    </small>
                    <span [countUp]="4546" class="text-warning"></span>
                </h3>
                <div class="text-first font-weight-bold">0%</div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5 bg-night-sky">
            <div class="text-white-50 pb-2">
                Income
            </div>
            <div class="d-flex justify-content-between align-items-end">
                <h3 class="display-4 mb-0">
                    <small class="pr-1 text-white-50">
                        $
                    </small>
                    <span class="text-white">3,21M</span>
                </h3>
                <div class="text-warning font-weight-bold">
                    -22%
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5 bg-amy-crisp">
            <div class="text-white-50 pb-2">
                Spendings
            </div>
            <div class="d-flex justify-content-between align-items-end">
                <h3 class="display-4 mb-0">
                    <small class="pr-1 text-white-50">
                        $
                    </small>
                    <span [countUp]="35465" class="text-white"></span>
                </h3>
                <div class="text-second font-weight-bold">
                    +65%
                </div>
            </div>
        </div>
    </div>
</div>
